import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ input, label, meta: { touched, error } }, radio = false) => (
  <div className={`form-group ${(touched && error) ? 'has-error' : ''}`}>
    <div>
      <input
        {...input}
        type={radio ? 'radio' : 'checkbox'}
        checked={input.value}
        onChange={() => input.onChange(!input.value)}
        onBlur={() => input.onChange(input.value)}
      />
      {label && <label className="input-label" htmlFor={input.name}>{label}</label>}
      {touched && error && <span className="error-message">{error}</span>}
    </div>
  </div>
);

const { string, object } = PropTypes;

Checkbox.propTypes = {
  input: object.isRequired,
  label: string,
  meta: object
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.js